import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from '@environments/environment';

@Component({
  selector: 'qb-de-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  environmentX = environment;

  constructor(private readonly platform: Platform) {}
}
